export default __webpack_public_path__ + "static/media/index-03.65de4107.jpg";